module.exports = __webpack_public_path__ + "static/media/15.adc5b475.png";